export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11870.85629c46.jpg";